import { useLayoutEffect, useRef, useState, Fragment } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useToggleState } from 'src/hooks/useToggleState';
import { GroupedMessages } from 'src/models/employer/resume/pinnedChatMessages';

import StaticCollapseTrigger from 'src/components/ResumeCard/Body/Collapse/Trigger/Static';

import styles from './message-group.less';

const isEllipsisActive = (element: HTMLElement) => element.offsetHeight < element.scrollHeight;

const TrlKeys = {
    expand: 'resume.pinnedChatMessage.showMore',
    collapse: 'resumeCard.trigger.collapse',
};

const MessageGroup: TranslatedComponent<{ messagesGroup: GroupedMessages }> = ({ trls, messagesGroup }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [showTrigger, setShowTrigger] = useState(false);
    const [expanded, toggleExpanded] = useToggleState(false);

    useLayoutEffect(() => {
        if (ref.current) {
            setShowTrigger(isEllipsisActive(ref.current));
        }
    }, []);

    return (
        <>
            <div ref={ref} className={expanded ? undefined : styles.clippedMessage}>
                {messagesGroup.messages.map(({ id, text }, index) => (
                    <Fragment key={id}>
                        {index !== 0 && <VSpacing default={8} />}
                        {text.replace(/\n\s*\n/g, '\n')}
                    </Fragment>
                ))}
            </div>
            {showTrigger && (
                <StaticCollapseTrigger
                    text={trls[expanded ? TrlKeys.collapse : TrlKeys.expand]}
                    expanded={expanded}
                    onToggle={toggleExpanded}
                />
            )}
        </>
    );
};

export default translation(MessageGroup);
